import i18n from 'modules/core/lib/i18n'

export const salaryFrequency = (frequency: string) => {
  switch (frequency) {
    case 'yearly':
      return i18n.t('common.yearly')
    case 'monthly':
      return i18n.t('common.monthly')
    case 'weekly':
      return i18n.t('common.weekly')
    case 'daily':
      return i18n.t('common.daily')
    case 'hourly':
      return i18n.t('common.hourly')
    default:
      return frequency
  }
}

export const workingHoursFrequency = (frequency: string) => {
  switch (frequency) {
    case 'year':
      return i18n.t('common.year')
    case 'month':
      return i18n.t('common.month')
    case 'week':
      return i18n.t('common.week.one')
    case 'day':
      return i18n.t('common.day.one')
    default:
      return frequency
  }
}
